import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import { literals } from "@/constants/literals";
import TerciaryButton from "@/components/buttons/terciary-button/TerciaryButton";

export type ConfirmPresendsStepProps = {
  saveOrder: () => void;
  openConfirmDiscardModal: () => void;
};

const ConfirmPresendsStep = ({
  saveOrder,
  openConfirmDiscardModal,
}: ConfirmPresendsStepProps) => {
  return (
    <div className="w-full grid gap-4">
      <div>
        <p className="text-sm text-ib-pt-color-gray-1000">
          {literals.confirmShortText}
        </p>
      </div>
      <PrimaryButton
        colour="red"
        label={literals.confirmAndExit}
        onClick={saveOrder}
        icon="checkUnderline"
      />
      <TerciaryButton
        colour="red"
        label={literals.discardOrder}
        onClick={openConfirmDiscardModal}
      />
    </div>
  );
};

export default ConfirmPresendsStep;
